<div class="w-full h-full">
    <app-tab-header [tabs]="tabs"></app-tab-header>

    <div class="px-5">
        <div class="flex w-full items-center justify-between">
            <h1 class="font-bold uppercase" style="font-size: 24px;">Buy load</h1>
            <div class="flex items-center gap-3">
                <ng-container *ngIf="getRefundButtonState() as btnState">
                    <button
                        [matTooltip]="btnState.tooltip"
                        [matTooltipDisabled]="!btnState.tooltip"
                        matTooltipClass="custom-orange-tooltip"
                        matTooltipPosition="left"
                        [disabled]="btnState.disabled"
                        [style.cursor]="btnState.disabled ? 'not-allowed' : 'pointer'"
                        [style.opacity]="btnState.disabled ? '0.6' : '1'"
                        (click)="openCreateDialog()"
                        class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-3"
                    >
                        Create
                    </button>
                </ng-container>
    
                <div style="min-width: 180px;">
                    <app-custom-dropdown-v2
                        label="Tier:"
                        labelWidth="40px"
                        [options]="tierOptions"
                        [selectedText]="selectedTierLabel"
                        placeholder="Select Tier"
                        (selectionChange)="onTierChange($event)">
                    </app-custom-dropdown-v2>
                </div>
            </div>
        </div>
        <!-- ── Buyload Data Table ── -->
        <div class="mt-4 bg-light-orange" style="border-left: 1px solid #CAC2BC; border-right: 1px solid #CAC2BC;">
            <app-data-table
                [tableSubHeader]="buyloadtableSubHeader"
                [isLoading]="isLoading"
                [centeredContent]="true"
            >
                <tr class="focus:outline-none" *ngFor="let item of itemLists">
                    <td class="font-bold">{{ rebateService.getProviderLabel(item.providerType) | nullWithDefault }}</td>
                    <td>{{ item.rebatePercentage | transformToDecimal }}%</td>
                    <td>{{ item.createUser | nullWithDefault }}</td>
                    <td>{{ item.createDate | asiaDate | nullWithDefault }}</td>                    
                    <td>{{ item.modifyUser | nullWithDefault }}</td>
                    <td>{{ item.modifyDate | asiaDate | nullWithDefault }}</td>
                    <td>
                        <span> {{ item.isEnabled ? 'Enabled' : 'Disabled' }}</span>
                    </td>
                    <td class="text-center">
                        <div class="flex items-center justify-center gap-1">
                            <ng-container *ngIf="getRefundButtonState() as btnState">
                                <!-- Edit -->
                                <button
                                    [matTooltip]="btnState.tooltip"
                                    [matTooltipDisabled]="!btnState.tooltip"
                                    matTooltipPosition="left"
                                    matTooltipClass="custom-orange-tooltip"
                                    [disabled]="btnState.disabled"
                                    [style.cursor]="btnState.disabled ? 'not-allowed' : 'pointer'"
                                    [style.opacity]="btnState.disabled ? '0.6' : '1'"
                                    class="custom-btn focus:outline-none"
                                    style="width:60px;height:23px;border-radius:5px;color:white;background:#3374b7;font-size:10px;"
                                    (click)="openEditDialog(item)">
                                    Edit
                                </button>

                                <!-- Enable / Disable toggle -->
                                <span
                                    [matTooltip]="btnState.disabled ? btnState.tooltip : ''"
                                    [matTooltipDisabled]="!btnState.disabled"
                                    matTooltipPosition="left"
                                    matTooltipClass="custom-orange-tooltip"
                                    [style.cursor]="(disablingUid === item.uid || btnState.disabled) ? 'not-allowed' : 'pointer'"
                                    style="display:inline-block;">

                                    <!-- Show "Enabled" button when item IS enabled -->
                                    <button
                                        *ngIf="item.isEnabled"
                                        class="custom-btn power-btn2 active focus:outline-none"
                                        [class.disabled]="disablingUid === item.uid || btnState.disabled"
                                        style="width:70px;height:23px;font-size:10px;"
                                        [style.pointer-events]="(disablingUid === item.uid || btnState.disabled) ? 'none' : 'auto'"
                                        [disabled]="disablingUid === item.uid || btnState.disabled"
                                        (click)="toggleStatusConfirmation(item)"
                                    >
                                        <ng-container *ngIf="disablingUid === item.uid; else enabledLabel">...</ng-container>
                                        <ng-template #enabledLabel>Enabled</ng-template>
                                    </button>

                                    <!-- Show "Disabled" button when item IS disabled -->
                                    <button
                                        *ngIf="!item.isEnabled"
                                        class="custom-btn power-btn2 focus:outline-none"
                                        [class.disabled]="disablingUid === item.uid || btnState.disabled"
                                        style="width:70px;height:23px;font-size:10px;"
                                        [style.pointer-events]="(disablingUid === item.uid || btnState.disabled) ? 'none' : 'auto'"
                                        [disabled]="disablingUid === item.uid || btnState.disabled"
                                        (click)="toggleStatusConfirmation(item)"
                                    >
                                        <ng-container *ngIf="disablingUid === item.uid; else disabledLabel">...</ng-container>
                                        <ng-template #disabledLabel>Disabled</ng-template>
                                    </button>

                                </span>
                            </ng-container>
                        </div>
                    </td>
                </tr>
    
                <!-- Empty state -->
                <tr *ngIf="!isLoading && itemLists.length === 0">
                    <td [attr.colspan]="buyloadtableSubHeader.length" class="text-center py-4 h-250-px text-gray-500 italic">
                        No rebate records found for the selected tier.
                    </td>
                </tr>
            </app-data-table>
        </div>
    <div class="flex w-full items-center justify-between mt-4">
        <h1 class="font-bold uppercase" style="font-size: 24px;">Distributor Group</h1>
    </div>
    <!-- ── RDPD Rebate Table ── -->
    <div class="mt-4 bg-light-orange" style="border-left: 1px solid #CAC2BC; border-right: 1px solid #CAC2BC; border-top: 1px solid #CAC2BC;">
        <app-data-table
            [tableSubHeader]="distributorTableSubHeader"
            [isLoading]="isLoadingDistributor"
            [centeredContent]="true"
        >
            <tr class="focus:outline-none" *ngFor="let row of distributorRows">
                <td>{{ row.label }}</td>
                <td>{{ row.value | transformToDecimal }}%</td>
                <td class="text-center">
                    <div class="flex items-center justify-center gap-1">
                        <ng-container *ngIf="getRefundButtonState() as btnState">

                            <!-- Edit -->
                            <button
                                [matTooltip]="btnState.tooltip"
                                [matTooltipDisabled]="!btnState.tooltip"
                                matTooltipPosition="left"
                                matTooltipClass="custom-orange-tooltip"
                                [disabled]="btnState.disabled"
                                [style.cursor]="btnState.disabled ? 'not-allowed' : 'pointer'"
                                [style.opacity]="btnState.disabled ? '0.6' : '1'"
                                class="custom-btn focus:outline-none"
                                style="width:60px;height:23px;border-radius:5px;color:white;background:#3374b7;font-size:10px;"
                                (click)="openEditDistributorDialog(row)">
                                Edit
                            </button>

                            <!-- Reset -->
                            <button
                                [matTooltip]="btnState.disabled ? btnState.tooltip : 'Reset rebates to 0%'"
                                matTooltipPosition="right"
                                matTooltipClass="custom-orange-tooltip"
                                [disabled]="btnState.disabled"
                                [style.cursor]="btnState.disabled ? 'not-allowed' : 'pointer'"
                                [style.opacity]="btnState.disabled ? '0.6' : '1'"
                                class="custom-btn power-btn2 focus:outline-none"
                                style="width:60px;height:23px;font-size:10px;"
                                (click)="resetDistributorRebatesConfirmation(row)">
                                Reset
                            </button>

                        </ng-container>
                    </div>
                </td>
            </tr>

            <!-- Empty state -->
            <tr *ngIf="!isLoadingDistributor && distributorRows.length === 0">
                <td [attr.colspan]="distributorTableSubHeader.length" class="text-center py-4 h-250-px text-gray-500 italic">
                    No distributor rebate records found.
                </td>
            </tr>
        </app-data-table>
    </div>
</div>
<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>